import { render, staticRenderFns } from "./switch_page.vue?vue&type=template&id=07943f67&scoped=true"
import script from "./switch_page.vue?vue&type=script&lang=js"
export * from "./switch_page.vue?vue&type=script&lang=js"
import style0 from "./switch_page.vue?vue&type=style&index=0&id=07943f67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07943f67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07943f67')) {
      api.createRecord('07943f67', component.options)
    } else {
      api.reload('07943f67', component.options)
    }
    module.hot.accept("./switch_page.vue?vue&type=template&id=07943f67&scoped=true", function () {
      api.rerender('07943f67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/switch_page.vue"
export default component.exports